import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { CompleteMembership } from '../../../../_global/fragments/generated/CompleteMembership';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type CreateMembershipsMutationVariables = Types.Exact<{
  input: Types.CreateMembershipsInput;
  locale?: Types.InputMaybe<Types.SupportedLocale>;
}>;


export type CreateMembershipsMutation = { __typename?: 'Mutation', createMemberships?: { __typename?: 'CreateMembershipsPayload', memberships?: Array<{ __typename?: 'Membership', id: string, type: string, accountUser?: { __typename?: 'AccountUser', accountUserType?: Types.AccountUserTypeEnum | null, avatarColor?: Types.AvatarColor | null, email?: string | null, id: string, inviteEmailAddress?: string | null, isPending: boolean, name?: string | null, profileImageUrl?: string | null, userId?: string | null, licenseType?: Types.AccountUserLicenseTypeValue | null } | null, accountUserGroup?: { __typename?: 'AccountUserGroup', accountId: string, emoji?: string | null, id: string, memberCount?: number | null, name?: string | null } | null, role?: { __typename?: 'Role', description?: string | null, id: string, name: string, order?: number | null } | null } | null> | null, metadata?: { __typename?: 'CreateMembershipsMetadata', userChanges?: Array<{ __typename: 'AccountUserAdded', email?: string | null, attributes?: { __typename?: 'AccountUserChangeAttributes', licenseType?: Types.AccountUserLicenseTypeValue | null } | null } | { __typename: 'AccountUserModified', accountUser?: { __typename?: 'AccountUser', id: string, email?: string | null, name?: string | null, avatarColor?: Types.AvatarColor | null, licenseType?: Types.AccountUserLicenseTypeValue | null, profileImage?: { __typename?: 'Images', image64?: string | null } | null } | null, previousAttributes?: { __typename?: 'AccountUserChangeAttributes', licenseType?: Types.AccountUserLicenseTypeValue | null } | null, newAttributes?: { __typename?: 'AccountUserChangeAttributes', licenseType?: Types.AccountUserLicenseTypeValue | null } | null } | { __typename: 'AccountUserNoop', accountUser?: { __typename?: 'AccountUser', id: string, email?: string | null, name?: string | null, avatarColor?: Types.AvatarColor | null, licenseType?: Types.AccountUserLicenseTypeValue | null, profileImage?: { __typename?: 'Images', image64?: string | null } | null } | null }> | null, predictedUsageByLicenseType?: { __typename?: 'SeatUsageByLicenseTypeMapping', member?: { __typename?: 'SeatUsage', overSeatLimit: boolean } | null, guest?: { __typename?: 'SeatUsage', overSeatLimit: boolean } | null } | null } | null } | null };


export const CreateMemberships = /*#__PURE__*/ gql`
    mutation CreateMemberships($input: CreateMembershipsInput!, $locale: SupportedLocale) {
  createMemberships(input: $input) {
    memberships {
      ...CompleteMembership
    }
    metadata {
      userChanges {
        __typename
        ... on AccountUserAdded {
          attributes {
            licenseType
          }
          email
        }
        ... on AccountUserModified {
          accountUser {
            id
            email
            name
            avatarColor
            licenseType
            profileImage {
              image64
            }
          }
          previousAttributes {
            licenseType
          }
          newAttributes {
            licenseType
          }
        }
        ... on AccountUserNoop {
          accountUser {
            id
            email
            name
            avatarColor
            licenseType
            profileImage {
              image64
            }
          }
        }
      }
      predictedUsageByLicenseType {
        member {
          overSeatLimit
        }
        guest {
          overSeatLimit
        }
      }
    }
  }
}
    ${CompleteMembership}` as unknown as DocumentNode<CreateMembershipsMutation, CreateMembershipsMutationVariables>;

          

          export const useCreateMembershipsMutation = (options?:MutationHookOptions<CreateMembershipsMutation, CreateMembershipsMutationVariables>) => useMutation(CreateMemberships, options);
          

          export type CreateMembershipsMutationOptions = MutationHookOptions<CreateMembershipsMutation, CreateMembershipsMutationVariables>;

          

          export type CreateMembershipsMutationResult = ReturnType<typeof useCreateMembershipsMutation>[1];

          
